import styled from "styled-components";
import {Button} from "../../../../../basic-ui-components/button/base/button.component";
import {styledByTheme} from "../../../../../themes/architecture/styled-by-theme";

export const AdvancedGamesFilterButtonBox = styled(Button)`
    min-width: 140px;
`

const  AdvancedGamesFilterButtonSIBox = styled(AdvancedGamesFilterButtonBox)`
    background-color: transparent; 
`

export const AdvancedGamesFilterButtonStyleBox = styledByTheme(AdvancedGamesFilterButtonBox)
    .forSI(AdvancedGamesFilterButtonSIBox)
    .forSICis(AdvancedGamesFilterButtonSIBox)
    .apply();